module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteLink":"delete"},"de":{"deleteLink":"löschen"}}')
  delete Component.options._Ctor
}
